module.exports = __webpack_public_path__ + "img/blog_17.bb8ae365.jpg";